import { FieldConfig } from '../../common/field-types';
import {
  COMPENSATION_PLAN_OPTIONS,
  FamilySavingsInsuranceFormValues,
  GENDER_OPTIONS,
  PAYMENT_PERIODICITY_OPTIONS,
  SAVINGS_MODE_OPTIONS,
} from './schema';

const isGoalMode = (v: FamilySavingsInsuranceFormValues) => v.savings_mode === 'goal_value';
const isCapacityMode = (v: FamilySavingsInsuranceFormValues) => v.savings_mode === 'savings_capacity';
const isWithdrawalMode = (v: FamilySavingsInsuranceFormValues) => v.savings_mode === 'withdrawal_goal';

// eslint-disable-next-line max-len
export const FAMILY_SAVINGS_INSURANCE_FIELDS: readonly FieldConfig<FamilySavingsInsuranceFormValues>[] = [
  {
    key: 'savings_mode', label: 'Modo de ahorro', kind: 'select', options: SAVINGS_MODE_OPTIONS,
  },
  { key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date' },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS,
  },
  {
    key: 'goal', label: 'Objetivo', kind: 'number', hint: 'UF', visibleWhen: isGoalMode,
  },
  {
    key: 'goal_value_withdrawal_month', label: 'Mes del retiro', kind: 'number', hint: 'Mes en que se retira el objetivo (modo Objetivo de ahorro)', colClassName: 'col-md-6', visibleWhen: isGoalMode,
  },
  {
    key: 'agreed_premium', label: 'Prima acordada', kind: 'number', hint: 'UF (mínimo 2)', visibleWhen: isCapacityMode,
  },
  {
    key: 'withdrawal_amount', label: 'Monto de retiro', kind: 'number', hint: 'UF', colClassName: 'col-md-6', visibleWhen: isWithdrawalMode,
  },
  {
    key: 'withdrawal_period_months', label: 'Periodicidad de retiro', kind: 'number', hint: 'Meses entre retiros', colClassName: 'col-md-6', visibleWhen: isWithdrawalMode,
  },
  {
    key: 'projection_rate', label: 'Tasa de proyección', kind: 'number', hint: 'Anual, ej. 0.03', step: 0.01,
  },
  {
    key: 'compensation_plan', label: 'Plan de compensación', kind: 'select', options: COMPENSATION_PLAN_OPTIONS,
  },
  {
    key: 'payment_periodicity', label: 'Periodicidad de pago', kind: 'select', options: PAYMENT_PERIODICITY_OPTIONS,
  },
  {
    key: 'unscheduled_annual_contribution', label: 'Aporte anual extra', kind: 'number', hint: 'UF',
  },
  {
    key: 'death_insured_capital', label: 'Capital muerte', kind: 'number', hint: 'UF (300 - 20.000)', colClassName: 'col-md-6',
  },
  {
    key: 'accidental_death_insured_capital', label: 'Capital muerte accidental', kind: 'number', hint: 'UF (= capital muerte o 0)', colClassName: 'col-md-6',
  },
  {
    key: 'itp_insured_capital', label: 'Capital ITP', kind: 'number', hint: 'UF (= capital muerte o 0)', colClassName: 'col-md-6',
  },
  {
    key: 'serious_illness_insured_capital', label: 'Capital enf. graves', kind: 'number', hint: 'UF (40% del capital muerte o 0)', colClassName: 'col-md-6',
  },
];
